export const MAX_RNP_FILE_SIZE = 15 * 1024 * 1024;

export function validateCompanyChangeForm({ ruc, companyName, file, sameCompanyConfirmed }) {
    if (!/^\d{11}$/.test(String(ruc || '').trim())) {
        return 'Ingresa un RUC válido de exactamente 11 dígitos.';
    }
    if (!String(companyName || '').trim()) {
        return 'Ingresa la razón social tal como aparece en la constancia RNP.';
    }
    if (!file) {
        return 'Adjunta la constancia RNP vigente en PDF.';
    }
    if (!file.name?.toLowerCase().endsWith('.pdf') || (file.type && file.type !== 'application/pdf')) {
        return 'La constancia debe ser un archivo PDF.';
    }
    if (file.size <= 0 || file.size > MAX_RNP_FILE_SIZE) {
        return 'La constancia debe pesar más de 0 y hasta 15 MB.';
    }
    if (!sameCompanyConfirmed) {
        return 'Confirma que corregirás los datos de la misma empresa.';
    }
    return null;
}